import React from "react";
import { Container, StepContainer, StepContentContainer, StepWrapper, StepStyle, StepCount, StepsLabelContainer, StepLabel, ButtonsContainer, ButtonStyle, CheckMark, StepTitleContainer, StepTitle, CountText, GroupInput, Label, CheckBox } from "./styles/stepBar";

export default function StepBar({children,...props}){
    return <Container {...props}>{children}</Container>
}

StepBar.StepContainer = function StepBarStepContainer({children,...props}){
    return <StepContainer {...props}>{children}</StepContainer>
}

StepBar.StepContentContainer = function StepBarStepContentContainer({children,...props}){
    return <StepContentContainer {...props}>{children}</StepContentContainer>
}

StepBar.StepTitleContainer = function StepBarStepTitleContainer({children,...props}){
    return <StepTitleContainer {...props}>{children}</StepTitleContainer>
}

StepBar.StepTitle = function StepBarStepTitle({children,...props}){
    return <StepTitle {...props}>{children}</StepTitle>
}

StepBar.CountText = function StepBarCountText({children,...props}){
    return <CountText {...props}>{children}</CountText>
}

StepBar.StepWrapper = function StepBarStepWrapper({children,...props}){
    return <StepWrapper {...props}>{children}</StepWrapper>
}

StepBar.StepStyle = function StepBarStepStyle({children,...props}){
    return <StepStyle {...props}>{children}</StepStyle>
}

StepBar.StepCount = function StepBarStepCount({children,...props}){
    return <StepCount {...props}>{children}</StepCount>
}

StepBar.StepsLabelContainer = function StepBarStepsLabelContainer({children,...props}){
    return <StepsLabelContainer {...props}>{children}</StepsLabelContainer>
}

StepBar.StepLabel = function StepBarStepLabel({children,...props}){
    return <StepLabel {...props}>{children}</StepLabel>
}

StepBar.ButtonsContainer = function StepBarButtonsContainer({children,...props}){
    return <ButtonsContainer {...props}>{children}</ButtonsContainer>
}

StepBar.ButtonStyle = function StepBarButtonStyle({children,...props}){
    return <ButtonStyle {...props}>{children}</ButtonStyle>
}

StepBar.CheckMark = function StepBarCheckMark({children,...props}){
    return <CheckMark {...props}>{children}</CheckMark>
}

StepBar.CheckBox = function StepBarCheckBox({...props}){
    return <CheckBox {...props} />
}

StepBar.Label = function StepBarLabel({children,...props}){
    return <Label {...props}>{children}</Label>
}

StepBar.GroupInput = function StepBarGroupInput({children,...props}){
    return <GroupInput {...props}>{children}</GroupInput>
}